<template>
  <div class="button-row">
    <button
      :class="{ current: getFilterCategory === 147 }"
      class="btn btn-primary"
      @click="setFilterCategory(147)"
      :disabled="loading"
    >
      Kalkit
    </button>
    <button
      :class="{ current: getFilterCategory === 39 }"
      class="btn btn-primary"
      @click="setFilterCategory(39)"
      :disabled="loading"
    >
      Lannoitteet
    </button>
    <button
      :class="{ current: getFilterCategory === 38 }"
      class="btn btn-primary"
      @click="setFilterCategory(38)"
      :disabled="loading"
    >
      Maanparannuskuidut
    </button>
    <button
      :class="{ current: getFilterCategory === 34049 }"
      class="btn btn-primary"
      @click="setFilterCategory(34049)"
      :disabled="loading"
    >
      Kuivikkeet
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { UPDATE_FILTER_CATEGORY } from "../../store/constants";

export default {
  name: "ButtonRow",
  computed: {
    ...mapGetters(["getFilterCategory"]),
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions({
      setFilterCategory: UPDATE_FILTER_CATEGORY,
    }),
  },
};
</script>

<style lang="scss" scoped>
.button-row {
  display: flex;
  flex-wrap: wrap;
  padding: 1rem 0;
  .btn {
    margin: 0.5rem 1rem 0.5rem 0;

    &:last-child {
      margin-right: 0;
    }
    &.current {
      background-color: var(--bs-green);
      border-color: var(--bs-green);
    }
    &:disabled {
      opacity: 0.8;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
</style>
